
/* 
// jQuery: initTabbedContent
// Tabbed Content is used for the display of slideshow, tab and photoviewer like content
// Clicking on a tab control performs some animation and then manipulates a set of tab content to display
*/

jQuery(function initTabbedContent($) {
	$('.js-tabbed-content-container').each(function(index, el) {

		var $container            = $(this);
		var $tabsContainer        = $container.find('.js-tabs');
		var $tabs                 = $container.find('.js-tab-content');
		var $controls             = $container.find('.js-tab-control');
		var currTabIndex          = 0;
		var numTabs               = $tabs.length;
		var maxTabIndex           = $tabs.length - 1;
		var isTransitioning       = false;
		var fadeParameters        = {duration: 500, queue: false};
		var autoTabTransitionTime = 6000;
		var automateTabs          = '';
		var autoplay              = $container.data('autoplay');

		var initializeWidget = function() {
			// Remove all but the first tab element from the DOM
			$tabs.each(function(index, el) {
				if (index > 0) { $(this).detach(); }
			});

			// Initialize the set of controls
			$($controls[0]).addClass('current');

			// Create click events for all tab controls
			$controls.each(function(index, el) {
				var tabIndex = index;
				$(this).click(function(event) {
					transitionPreviousTab(tabIndex, true);
				});
			});
		};

		var transitionPreviousTab = function(tabIndex, autoPlaySwitch) {
			if (!isTransitioning && tabIndex !== currTabIndex) {
				
				// If the user has clicked a control for a specific tab, disable the autoPlay
				if (autoPlaySwitch) {
					stopAutoplay();
				}
	
				isTransitioning = true;
				var currTab  = $($tabs[currTabIndex]);

				// This code allows for a height transition to occur
				var currentHeight = currTab.height();
				$tabsContainer.height(currentHeight);
				
				currTab.fadeOut($.extend({}, fadeParameters, {
					complete: function() {
						currTab.detach();
						transitionNewTab(tabIndex);
					}
				}));
			}
		};

		var transitionNewTab = function(tabIndex) {
			var newTab = $($tabs[tabIndex]);
			newTab.appendTo($tabsContainer).hide();
			updateControls(tabIndex);

			// This code allows for a height transition to occur
			// This can be converted to remove the height adjustment by removing the outer animate, and then
			// removing the css and height calculations
			var currentHeight = newTab.height();
			$tabsContainer.animate({duration: 500, queue: false, height: currentHeight}, {
				complete: function() {
					newTab.fadeIn($.extend({}, fadeParameters, {
						complete: function() {
							currTabIndex = tabIndex;
							isTransitioning = false;
							$tabsContainer.css('height','auto');
						}
					}));
				}
			});
		};

		var updateControls = function(tabIndex) {
			// Turn off the previous tab control
			$($controls[currTabIndex]).removeClass('current');

			// Turn on the new tab control
			$($controls[tabIndex]).addClass('current');
		};

		var startAutoplay = function() {
			automateTabs = setInterval(tabTimer, autoTabTransitionTime);
		};

		var stopAutoplay = function() {
			clearInterval(automateTabs);
		};

		var tabTimer = function() {
			if (currTabIndex >= maxTabIndex) {
				transitionPreviousTab(0, false);
			} else {
				transitionPreviousTab(currTabIndex + 1, false);
			}
		};

		if (numTabs > 0) {
			initializeWidget();

			if (numTabs > 1 && autoplay === 'yes') {
				startAutoplay();
			}
		}
	});
});